module.exports = __webpack_public_path__ + "static/media/business-1.04e0162c.jpg";